import { useSelector } from "react-redux";
import { DashboardSidebar } from "./DashboardSidebar";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function DashboardLayout({route, children}) {
    // useSelector
    const user = useSelector((state) => state.user);

    // navigate
    const navigate = useNavigate();

    // useEffect
    useEffect(() => {
        if (!user.isLoggedIn) {
            navigate("/");
        }
    }, [user.isLoggedIn, navigate]);

    return (
        <div className="flex">
          {/* Sidebar */}
          <DashboardSidebar route={route} userName={user?.user?.first_name || "Eagle"} />
    
          {/* Main Content */}
          <div className="flex-1 p-6 bg-stone-100 pl-64 ml-7 min-h-screen">
            {user.isLoggedIn ? children : "Loading..."}
          </div>
        </div>
      );
}